export enum MODULES_ENUM {
    PROFILE = 1,
    POLICES,
    PATROL_UNIT,
    EMPLOYEES,
    PLACES,
    INVENTORY,
    HONOR_AND_JUSTICE_COUNCIL,
    EMPLOYEE_COURSES,
    ATTENDANCE_ENTRIES,
    ATTENDANCE_EXITS,
    ARMORY,
    WEAPONS_OR_DEVICES_EXIT_CONTROL,
    DETAINEES,
    MEDICAL_CERTIFICATION,
    IPH,
    REPUVE,
    ASSIGNED_UNITS,
    EMPLOYEE_PERMISSIONS,
    SCREENING,
    COURT_HEARINGS,
    EVENTS,
    PENDING_EXITS,
    DETAINEES_HISTORY,
    INTERNAL_AFFAIRS,
    ATTENDANCE_CONCILIATION,
    COMMISIONED,
    STATISTICS,
    SHIFT_SCHEDULE,
    ASSIGNMENTS,
    INCIDENTS,
    DASHBOARDS = 31,
    UNIT_TRACKING = 32,
    PATROL_WORKSHOP = 33,
    CIVIC_COURT = 34,
    DISTRESS_CALLS = 35,
}